import { rivenAuthGoogleOneTapCookieKey } from '@rivenai/connector-kit';
import { adminConsoleApplicationId, rivenAuthCookieKey, rivenAuthUiCookieGuard } from '@rivenai/schemas';
import { trySafe } from '@silverhand/essentials';
import { getCookie } from 'tiny-cookie';

export const rivenAuthCookies =
  trySafe(() => rivenAuthUiCookieGuard.parse(getCookie(rivenAuthCookieKey, JSON.parse))) ?? {};

export const shouldTrack = rivenAuthCookies.appId === adminConsoleApplicationId;

export const rivenAuthGoogleOneTapCookie =
  trySafe(() => {
    const cookieValue = getCookie(rivenAuthGoogleOneTapCookieKey);
    return cookieValue ?? null;
  }) ?? null;
